export default {
  me: {
    mfaEnabled: false,
    totp: undefined,
    assignedTasks: [],
    preferences: {
      dateTo: null,
      dateFrom: null,
      timeline: {
        conversations: false,
        created: false,
        documents: false,
        participants: false,
        stateChanges: false,
        tasks: false,
        updates: false,
        viewed: false
      }
    }
  },
  account: {
    caseTypes: [],
    serviceLevelCriteria: [],
    emailAccounts: [],
    savedSearches: [],
    refreshTokenExpiryHours: 24,
    auditEnabled: false,
    adminConsoleToken: null,
    oidcSso: null
  },
  isCurrentUserLoading: true,
  taskResult: {},
  taskRunning: true
}
